import { FIND_TARGET_CORRECTION_PAYMENT_BY_MEETING_ID } from '../TargetCorrectionQueries'
import { TargetCorrectionPaymentByMeetingIdQueryVariables, TargetCorrectionPaymentByMeetingIdQuery } from '../../../types'
import { ApolloError, useQuery } from '@apollo/client'

export default (
  meetingId: number,
): {
  loading_tcp: boolean
  error_tcp: ApolloError | undefined
  data_tcp: TargetCorrectionPaymentByMeetingIdQuery | undefined
} => {
  const { data, error, loading } = useQuery<TargetCorrectionPaymentByMeetingIdQuery, TargetCorrectionPaymentByMeetingIdQueryVariables>(
    FIND_TARGET_CORRECTION_PAYMENT_BY_MEETING_ID,
    {
      variables: {
        meetingId: meetingId,
      },
      fetchPolicy: 'cache-and-network',
    },
  )
  return { loading_tcp: loading, error_tcp: error, data_tcp: data }
}
